export default [
    {
        path: "/",
        name: "home",
        component: () => import(/* webpackChunkName: "home" */ "@/views/home.vue"),
        meta: {
            title: "常见问题",
            subtitle: "常见问题"
        }
    },
    {
        path: "/home",
        name: "home",
        component: () => import(/* webpackChunkName: "home" */ "@/views/home.vue"),
        meta: {
            title: "常见问题",
            subtitle: "常见问题"
        }
    },
    {
        path: "/topClass",
        name: "topClass",
        component: () => import(/* webpackChunkName: "topClass" */ "@/views/topClass.vue"),
        meta: {
            title: "常见问题",
            subtitle: ""
        }
    },
    {
        path: "/secondaryClass",
        name: "secondaryClass",
        component: () => import(/* webpackChunkName: "secondaryClass" */ "@/views/secondaryClass.vue"),
        meta: {
            title: "常见问题",
            subtitle: ""
        }
    },
    {
        path: "/detail",
        name: "detail",
        component: () => import(/* webpackChunkName: "detail" */ "@/views/detail.vue"),
        meta: {
            title: "常见问题",
            subtitle: "问题详情"
        }
    },
    {
        path: "/search",
        name: "search",
        component: () => import(/* webpackChunkName: "search" */ "@/views/search.vue"),
        meta: {
            title: "常见问题",
            subtitle: "搜索结果"
        }
    },
    {
        path: "/previewDetail",
        name: "previewDetail",
        component: () => import(/* webpackChunkName: "previewDetail" */ "@/views/previewDetail.vue"),
        meta: {
            title: "常见问题",
            subtitle: "问题详情"
        }
    },
    {
        path: "/otcDetail",
        name: "otcDetail",
        component: () => import(/* webpackChunkName: "otcDetail" */ "@/views/otcDetail.vue"),
        meta: {
            title: "常见问题",
            subtitle: "问题详情"
        }
    }
]